export default __webpack_public_path__ + "static/media/marker_green.1d5ec428.svg";